module.exports = __webpack_public_path__ + "static/media/LRC.fcc3a94d.svg";